import React from "react";
import close from "../../../../images/demo/pages/closeresult.svg";
import ResultView from "../ResultView";
import ResultViewThreeScore from "../ResultViewThreeScore";

function ResultScore({result, closeResult, min, max, middle, moderate, data}) {

    return (
        result.length > 0 &&
        <div className="result-model">
            <div className="inset-result">
                <div className="form-result">
                    <img onClick={() => closeResult()}
                         className="close-result" src={close} alt=""/>
                    <h1 className="title-result">Score Model</h1>
                    <h1 className="title-result">calculation results</h1>
                    {
                        result.map((r, index) =>
                            r.model.technical_model_name === "ScoreAbsoluteRiskValue" ?
                                r.data &&
                                    <div key={index} className="mb-4 mt-4">
                                        {
                                            r.data.map((rd, index) =>
                                                rd.id_result === 100000 ?
                                                    <div key={index}>
                                                        <h6 className="title-result-little">RISK FOR SMOKERS:</h6>
                                                        <ResultViewThreeScore dataText={data[0].absolute} max={max} min={min} middle={middle} moderate={moderate}
                                                                    data={rd.result}/>
                                                    </div> :
                                                    <div key={index}>
                                                        <h6 className="title-result-little">RISK FOR NON-SMOKERS:</h6>
                                                        <ResultViewThreeScore dataText={data[0].absolute} max={max} min={min} middle={middle} moderate={moderate}
                                                                    data={rd.result}/>
                                                    </div>
                                            )
                                        }
                                    </div>
                                :
                                r.data &&
                                    <div className="mb-4 mt-4">
                                        {
                                            r.data.map((rd, index) =>
                                                rd.id_result === 100002 ?
                                                    <div key={index}>
                                                        <h6 className="title-result-little">RISK FOR SMOKERS:</h6>
                                                        <ResultView dataText={data[0].relative} max={max} min={min} middle={12}
                                                                    data={rd.result}/>
                                                    </div> :
                                                    <div key={index}>
                                                        <h6 className="title-result-little">RISK FOR NON-SMOKERS:</h6>
                                                        <ResultView dataText={data[0].relative} max={max} min={min} middle={12}
                                                                    data={rd.result}/>
                                                    </div>
                                            )
                                        }
                                    </div>
                        )
                    }
                    {
                        result[0].data === null && result[1].data === null &&
                        <div className="mb-4 mt-4">
                            <h1 className="title-result text-danger">Data error</h1>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default ResultScore;